import Card from 'components/Card/Card.jsx';
import Button from 'components/CustomButton/CustomButton.jsx';
import Checkbox from 'components/CustomCheckbox/CustomCheckbox.jsx';
import React, { Component } from 'react';
import {
    Alert,
    Col,
    ControlLabel,
    FormControl,
    FormGroup,
    Grid,
    Row
} from 'react-bootstrap';
import auth from '../../lib/auth';

class LoginPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cardHidden: false,
            email: '',
            password: '',
            recordLogin: false,
            error: null
        };

        this.onChange = this.onChange.bind(this);
        this.onLogin = this.onLogin.bind(this);
    }
    componentDidMount() {
        // setTimeout(
        //   function() {
        //     this.setState({ cardHidden: false });
        //   }.bind(this),
        //   50
        // );
    }

    onChange = event => {
        var id = event.target.id;
        var value = event.target.value;
        this.setState({ [id]: value });
        // this.setState(state);
    };

    onLogin = async () => {
        try {
            var loginResponse = await auth.login(
                this.state.email,
                this.state.password,
                async userResult => {
                    window.location.href = '/#/admin';
                }
            );
        } catch (e) {
            this.setState({ error: e });
        }
    };

    hideError = () => {
        this.setState({ error: null });
    };

    render() {
        const Error = () => (
            <Alert bsStyle="danger">
                <button
                    type="button"
                    aria-hidden="true"
                    className="close"
                    onClick={this.hideError}
                >
                    ×
                </button>
                <span>
                    <b> Error - </b> {this.state.error}
                </span>
            </Alert>
        );

        return (
            <Grid>
                <Row>
                    <Col md={4} sm={6} mdOffset={4} smOffset={3}>
                        <form
                            onSubmit={event => {
                                event.preventDefault();
                                this.onLogin;
                            }}
                        >
                            <Card
                                hidden={this.state.cardHidden}
                                textCenter
                                title="Iniciar Sesión"
                                content={
                                    <div>
                                        {this.state.error && <Error />}
                                        <FormGroup>
                                            <ControlLabel>
                                                Correo electrónico
                                            </ControlLabel>
                                            <FormControl
                                                placeholder="Ingresa tu correo"
                                                type="email"
                                                id="email"
                                                onChange={this.onChange}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <ControlLabel>
                                                Contraseña
                                            </ControlLabel>
                                            <FormControl
                                                placeholder="Ingresa tu password"
                                                type="password"
                                                id="password"
                                                onChange={this.onChange}
                                            />
                                        </FormGroup>
                                        {/* <FormGroup>
                                            <Checkbox
                                                id="recordLogin"
                                                label="Recordar credenciales"
                                                isChecked={
                                                    this.state.recordLogin
                                                }
                                                onClick={this.onChange}
                                            />
                                        </FormGroup> */}
                                    </div>
                                }
                                legend={
                                    <Button
                                        bsStyle="info"
                                        fill
                                        wd
                                        type="submit"
                                        onClick={this.onLogin}
                                    >
                                        Iniciar
                                    </Button>
                                }
                                ftTextCenter
                            />
                        </form>
                    </Col>
                </Row>
            </Grid>
        );
    }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/views/Pages/LoginPage.jsx